import React from 'react';
import {Route, Routes} from 'react-router-dom';
import {withLazyComponent} from './lazyComponent';
import {protectedRoute} from './protectedRoute';
import {publicRoute} from './publicRoute';
import {useRecoilValue} from 'recoil';
import {globalAccountVerificationProfileState, globalBrandModuleSettingState, globalEWalletSettingState, globalUserDetailState, globalUserVerifyState} from '../_common/global_state';
import Layouts from '../layouts';
import useShared from '../_common/_shared';
import AccountVerificationV2 from '../pages/accountVerificationV2/view';

const Page404 = withLazyComponent(React.lazy(() => import('../pages/_error/page404')));
const PageNotVerify = withLazyComponent(React.lazy(() => import('../pages/_error/pageNotVerify')));

const RouterComponent = () => {
  const userVerifyState = useRecoilValue(globalUserVerifyState);
  const brandWebModuleSetting = useRecoilValue(globalBrandModuleSettingState);
  const userDetailState = useRecoilValue(globalUserDetailState);
  const eWalletSetting = useRecoilValue(globalEWalletSettingState);
  const accountVerificationProfile = useRecoilValue(globalAccountVerificationProfileState);
  const {checkUserAccessRight} = useShared();

  const filteredModule = [];
  if (eWalletSetting?.depositWithKyc) {
    filteredModule.push('ewallet-deposit');
  }

  if (eWalletSetting?.withdrawalWithKyc) {
    filteredModule.push('ewallet-withdrawal');
  }

  const isKycKybVerified = userDetailState?.isKycApproved || userDetailState?.isKybApproved;
  return (
    <Routes>
      <Route key="home" path="/" element={<Layouts />}>
        {userVerifyState && accountVerificationProfile?.accessRights ? (
          <>
            {protectedRoute &&
              protectedRoute.map((item, index) => {
                const moduleSetting = brandWebModuleSetting?.find((module) => module?.name === item?.moduleName);
                const moduleEnabled = moduleSetting ? moduleSetting?.isEnabled : true;
                // const moduleEnabled = true;
                let routeElement = <item.element />;
                if ((filteredModule.includes(item?.id) && !checkUserAccessRight(item?.id) && !isKycKybVerified) || (item?.id && !checkUserAccessRight(item?.id))) {
                  routeElement = <PageNotVerify />;
                }

                return moduleEnabled ? <Route key={index} path={item?.path} element={routeElement} /> : null;
              })}
          </>
        ) : (
          <>
            <Route key="dashboard" path="/dashboard" element={<PageNotVerify />} />
            <Route key="account-verification" path="/account-verification" element={<AccountVerificationV2 />} />
          </>
        )}
      </Route>
      <Route path="*" element={<Page404 />} />

      <Route path="/">
        {publicRoute &&
          publicRoute.map((item, index) => {
            return <Route key={index} path={item?.path} element={<item.element />} />;
          })}
      </Route>
    </Routes>
  );
};

export default RouterComponent;
